import React from 'react';
import styled from "styled-components";


const HeroEnglish = () => {
    return (
        <Wrapper>
            <Content>
                <h2>IDEA: Competition for a poster: 550th birthday of Nicolaus
                    Copernicus</h2>
                <p>Have you heard anything about Copernicus? We would like to invite you to participate in a
                    poster competition commemorating the 550th birthday of Nicolaus Copernicus! </p>

                <p> 19
                    February 2023 marks the 550th anniversary of the birth of the eminent scientist and
                    astronomer Nicolaus Copernicus, who not only made one of the most important discoveries
                    in history, but also started a scientific revolution that changed the way we see the world. He
                    is an extremely important figure for the history of both Poland and the world. As a
                    Renaissance man, Nicolaus Copernicus was involved in many fields of science; astronomy,
                    astrology, mathematics, economics, cartography and philology. </p>
                <p> The competition is held as part of the World Copernicus Congress, on the occasion of the
                    2023 Year of Nicolaus Copernicus established by a resolution of the Senate of the Republic
                    of Poland. The Congress is organised jointly by Nicolaus Copernicus University in Toruń,
                    Jagiellonian University in Kraków, University of Warmia and Mazury in Olsztyn and the
                    Polish Academy of Sciences. </p>


                <h2>PURPOSE OF THE COMPETITION:</h2>
                <p> To select the most interesting posters, graphic creations on the theme of the competition;
                    the 550th birthday of Nicolaus Copernicus.
                </p>
                <h2>AWARDS:</h2>
                <p>An international jury will select the winners from the submitted entries:</p>
                <p> Grand prix - PLN 3000 </p>
                <p>1st Prize- 2000 PLN, </p>
                <p> 2nd Prize- 1500 PLN </p>
                <p>3rd Prize- 1000 PLN,</p>
                <p>honorable mention- 500 PLN</p>

                <p>and a maximum of 100 finalists, whose posters will be presented in post-competition exhibitions at
                    the Stara Kotłownia Expo Centre in Olsztyn, and in Frombork and Toruń. Of the posters
                    shortlisted for the finals, the 20 best will be exhibited in the urban space of Olsztyn, Frombork
                    and at the Final Gala in Olsztyn during the Copernican Conference.
                </p>


                <h2>DEADLINES:</h2>
                <p>Announcement of the competition: 18 February 2023</p>
                <p>Opening of registration of works: 15 March 2023</p>
                <p>Date of submission of projects: 30 April 2023, 11.59 pm</p>
                <p>List of successful applicants: 15 May 2023</p>
                <p>Hi-Res file submission date: 30 May 2023</p>
                <p>Announcement of finalists and winners: June 2023</p>
                <p>Exhibitions: June — December 2023</p>

                <h2>HOW TO SUBMIT A POSTER</h2>
                <p> 1. The competition is open to students and graduates who have completed their studies
                    within the last 5 years</p>
                <p> 2. Each participant can submit a maximum of 3 different posters</p>
                <p>3. Entries can only be submitted online by completing the entry form:
                    https://rokkopernika.uwm.edu.pl/konkurs/</p>
                <p>4. Specifics: entry format: 7 x 10 cm poster preview, 300 dpi, RGB, jpg</p>

                <h3>DEADLINE FOR SUBMISSIONS: 30.04.2023 (23:59 GMT)</h3>

                <h2>SUBMISSION OF COMPETITION ENTRIES:</h2>
                <p>1. Submit your posters via the form on the competition page: format: 10 × 7 cm (vertical
                    orientation), 300 dpi, RGB, jpg (maximum 5 MB) by 30 April 2023</p>
                <p> 2. Name the file of the work with your name and number e.g. adam_kowalsky_1.jpg. It is
                    forbidden to mention your name anywhere on the work.</p>
                <p> 3. Deadline for submission of competition entries (previews): 30 April 2023.</p>
                <p>4. Final deadline for submission of works selected for the competition final, Hi-Res print files;
                    100x70cm, 200 dpi, CMYK, jpg, (maximum 30 MB): 30 May 2023.</p>
            </Content>
        </Wrapper>
    )
}

export default HeroEnglish


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
  }

  h3 {
    font-family: Lato;
    color: white;
    background-color: #E44432;
    font-size: 20px;
    font-weight: 600;
    padding: 20px;
    border-radius: 50px;
  }

  h2 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 0px 10px;
    border-radius: 50px;
  }

  p {
    margin: 0;
    font-family: Lato;
    margin-bottom: 12px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1.5;
  }
`


const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
    box-sizing: border-box;
    padding: 20px;
  }
`



